import { selectPositionEntryState } from './store/selectors';
import State from 'store/State';
import { PortfolioInput } from 'portfolio/PortfolioInput';
import {
    PortfolioItem,
    defaultPortfolioItemColumns,
    initialPortfolioItem,
} from 'portfolio/PortfolioItem';
import {
    buildPortfolioSelection,
    PortfolioPosition,
    PortfolioSelection,
} from 'portfolio/PortfolioSelection';
import { selectAppSettings } from 'app/store/appSettings/selectors';

/*
 * The Portfolio Input implementation for Position Entry
 */
export const PositionEntryPortfolioInput: PortfolioInput = {
    getFilteredPortfolio,
    getFilteredOrders: () => [],
    usesOrdersStream: () => false,
    getPortfolioColumns: () => defaultPortfolioItemColumns,
    getSelection: getPositionEntryPortfolioSelection,
};

/*
 * The filtered portfolio is the one entered position
 */
function getFilteredPortfolio(state: State): PortfolioItem[] {
    const positionEntryState = selectPositionEntryState(state);

    return positionEntryState.position
        ? [
              {
                  ...initialPortfolioItem,
                  ...positionEntryState!.position,
              },
          ]
        : [];
}

/*
 * The selection is build from the one entered position
 */
export function getPositionEntryPortfolioSelection(
    state: State
): PortfolioSelection {
    const { symbology } = selectAppSettings(state);
    const positionEntryState = selectPositionEntryState(state);
    const selectedPositions: PortfolioPosition[] = positionEntryState.position
        ? [positionEntryState.position]
        : [];
    return buildPortfolioSelection({ selectedPositions, symbology });
}
